module.exports = __webpack_public_path__ + "img/16_mark_d.9e13faba.png";